import React from "react";
import { Pagination, PaginationItem, PaginationLink, Row, Col, NavLink } from "reactstrap";
import MoreHorizIcon from "@material-ui/icons/MoreHoriz";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import Popover from "@material-ui/core/Popover";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import AccountTreeIcon from "@material-ui/icons/AccountTree";
import NoteAddIcon from "@material-ui/icons/NoteAdd";
import DeleteIcon from "@material-ui/icons/Delete";
import SettingsIcon from "@material-ui/icons/Settings";
import ConfirmModal from "../../../../components/ConfirmModal/ConfirmModal";
import LastPageIcon from "@material-ui/icons/LastPage";
import FirstPageIcon from "@material-ui/icons/FirstPage";
import "./Pagination.css";
import SystemLabel from "../../../../../system/SystemLabel/SystemLabel";

export const FormPagination = ({ pages, currentPage, navigate, addPage, removePage, showMore, showSettings }) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [showModal, setModal] = React.useState(false);
  const drawPageTabs = (totalPages, currentPage, navigate) => {
    let startPage = currentPage - 1;
    let endPage = currentPage + 1;

    if (startPage <= 0) {
      endPage -= startPage - 1;
      startPage = 1;
    }

    if (endPage > totalPages) {
      endPage = totalPages;
    }

    let pageTabs = [];

    for (let index = startPage; index <= endPage; index++) {
      pageTabs.push(
        <PaginationItem key={index}>
          <PaginationLink className={currentPage === index ? "jirango-active" : "jirango-not-active"} disabled={currentPage === index} onClick={() => navigate(index)}>
            {index}
          </PaginationLink>
        </PaginationItem>
      );
    }
    return pageTabs;
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const onRemovePage = () => {
    removePage();
    setModal(false);
  };
  const toggleModal = () => {
    setModal(!showModal);
  };
  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;
  return (
    <Row style={{ margin: "0px", width: "100%" }}>
      <Col style={{ padding: "0px" }}>
        <Pagination size="5">
          {pages > 3 ? (
            <PaginationItem>
              <PaginationLink disabled={currentPage === 1} onClick={() => navigate(1)}>
                <FirstPageIcon style={{ fontSize: "15px" }} />
              </PaginationLink>
            </PaginationItem>
          ) : null}
          <PaginationItem>
            <PaginationLink disabled={currentPage === 1} onClick={() => (currentPage > 1 ? navigate(currentPage - 1) : null)}>
              <i className="fa fa-chevron-left page-icon" />
            </PaginationLink>
          </PaginationItem>
          {drawPageTabs(pages, currentPage, navigate).map((p) => {
            return p;
          })}
          <PaginationItem>
            <PaginationLink disabled={currentPage === pages} onClick={() => (currentPage < pages ? navigate(currentPage + 1) : null)}>
              <i className="fa fa-chevron-right page-icon" />
            </PaginationLink>
          </PaginationItem>
          {pages > 3 ? (
            <PaginationItem>
              <PaginationLink disabled={currentPage === pages} onClick={() => navigate(pages)}>
                <LastPageIcon style={{ fontSize: "15px" }} />
              </PaginationLink>
            </PaginationItem>
          ) : null}
        </Pagination>
      </Col>
      <Col style={{ padding: "0px", textAlign: "right" }}>
        <div className="page-settings">
          <MoreVertIcon aria-describedby={id} className="sidebar-icon" onClick={handleClick} />
          <Popover
            id={id}
            open={open}
            anchorEl={anchorEl}
            onClose={handleClose}
            style={{ zIndex: 10000, padding: "10px" }}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "center",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "center",
            }}
          >
            <Row style={{ margin: "0px" }}>
              <Col style={{ padding: "0px" }}>
                <NavLink className="list-option" onClick={addPage}>
                  {" "}
                  <NoteAddIcon className=" pop-list-icon" /> <SystemLabel name="AddPage" />
                </NavLink>
              </Col>
            </Row>
            <hr className="thin-hr" />
            <Row style={{ margin: "0px" }}>
              <Col style={{ padding: "0px" }}>
                <NavLink className="list-option" onClick={toggleModal}>
                  <DeleteIcon className="pop-list-icon" />
                  Ta bort sida
                </NavLink>
              </Col>
            </Row>
          </Popover>
          <ConfirmModal header="AreYouSure" text="DeletePageInfo" open={showModal} onCancel={toggleModal} onAction={onRemovePage} />
        </div>
      </Col>
    </Row>
  );
};
